import { interval, Observable, of, throwError } from 'rxjs';
import { flatMap, retryWhen } from 'rxjs/operators';

export function httpRetry(maxRetry: number = Infinity, delayMs: number = 5000) {
  return (src: Observable<any>) =>
    src.pipe(
      retryWhen((err) => {
        return interval(delayMs).pipe(
          flatMap((count) =>
            count === maxRetry ? throwError('Giving up') : of(count)
          )
        );
      })
    );
}
